import React, { useState } from 'react';
import "./StandarService.scss"
import imgMenSuit from "../../assets/photos/MenSuit.jpg"

import imgMenUniform from "../../assets/photos/UniformMen.jpg"

import imgSamedayRush from "../../assets/photos/WomanDress2.jpg"
import { Helmet } from "react-helmet-async";


const servicesSpecialty =  [
  {
    title: "Men Suits",
    options: ["Sleeves (Shorten / Lengthen)", "Center Seam close", "Taper Sides In / Out", "Shorten Jacket", "Waist Adjustment" , "Crotch Fit", "Tapering" , "Hemming"],
    image: imgMenSuit,
  },
  {
    title: "Uniform & Retail",
    options: ["This service specializes in altering, tailoring, and customizing clothing to ensure a perfect fit and polished look for employees or retail merchandise.","It focuses on precision, quality craftsmanship, and meeting the specific needs of clients across hospitality, corporate, and retail industries."],
    image: imgMenUniform,
  },
  {
    title: "Same day rush",
    options: ["Same-day rush services provide quick alterations or tailoring completed within 24 hours, ideal for urgent needs. This option ensures your garments are perfectly fitted and ready to wear on short notice, offering convenience and efficiency for time-sensitive requests. ","Please note that availability for same-day rush services may vary, so it’s recommended to check with the business in advance."," An additional fee may apply for this expedited service."],
    image: imgSamedayRush,
  }
];

  const SpecialtyService = () => {
    const [selectedService, setSelectedService] = useState(servicesSpecialty[0]);


  return (
    <div className='StandarService'>
      <Helmet>
        <title>Specialty Alterations | Alterations by Sdenka and Paola | Cooper City, FL</title>
        <meta name="description" content="Specialized alterations for vintage clothing, delicate fabrics, and unique designs. Expert craftsmanship in Cooper City, FL." />
        <link rel="canonical" href="https://yourwebsite.com/services/specialty" />
      </Helmet>
      <h1>A glimpse of our alteration services - expert tailoring for all your needs</h1>
    <div className="container">
    
      <div className="menu">
        {servicesSpecialty.map((item) => (
          <div key={item.title} className="menu-section">
            <button className="menu-title" onClick={() => setSelectedService(item)}>
              {item.title}
              <span>{selectedService ===item ? "▼" : "▶"}</span>
            </button>
            {selectedService ===item &&
             (
              <div className="submenu">
                {item.options.map((subItem) => (
                  <div key={subItem} className="submenu-item">
                    {subItem} 
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="image-section">
        <img src={selectedService.image} alt="Fashion Style" />
      </div>
    </div>
    </div>
  );
}
  

export default SpecialtyService;